import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { Badge } from '@perch-labs/shrike';

export const DesktopOnlySVG = styled(SVG).attrs({
  height: '32px',
  width: '32px',
})`
  ${props => props.theme.media.small`
    display: none;
  `}
`;

export const StyledBadge = styled(Badge)`
  height: fit-content;
`;
